import React, { useState } from "react";
import Checkout from "../components/MinerStore/StorePayment/Checkout";
import Navbar from "../components/Navbar";
import ScrollToTop from "../components/ScrollToTop";
import Sidebar from "../components/Sidebar";
function StorePayment() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <ScrollToTop />
      <div style={{ marginTop: "100px" }}>
        <Checkout />
      </div>
    </>
  );
}

export default StorePayment;
